export default "__VITE_PUBLIC_ASSET__5b2ddd9e__"